import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import {
  CreateMarketplaceUserRequest,
  MarketplaceUser,
  SendMarketplaceUserInvitationRequest,
  UpdateMarketplaceUserRequest,
} from './marketplace.users.types';

export const getMarketplaceUsers = async (
  apiBaseUri: string,
  marketplaceId: string,
): Promise<Array<MarketplaceUser>> => {
  const options = await getFetchOptions('GET');

  return await fetch(`${apiBaseUri}/marketplaces/${marketplaceId}/users`, options).then(handleResponse);
};

export const createMarketplaceUser = async (
  apiBaseUri: string,
  marketplaceId: string,
  payload: CreateMarketplaceUserRequest,
): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/marketplaces/${marketplaceId}/users`, options).then(handleResponse);
};

export const updateMarketplaceUser = async (
  apiBaseUri: string,
  marketplaceId: string,
  userId: string,
  payload: UpdateMarketplaceUserRequest,
): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiBaseUri}/marketplaces/${marketplaceId}/users/${userId}`, options).then(handleResponse);
};

export const sendInviteEmail = async (
  apiBaseUri: string,
  marketplaceId: string,
  payload: SendMarketplaceUserInvitationRequest,
): Promise<void> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));

  return await fetch(`${apiBaseUri}/marketplaces/${marketplaceId}/users/send-platform-user-invite-email`, options).then(
    handleResponse,
  );
};
